export default __webpack_public_path__ + "static/media/clio-rs-medium1.11f6ffa4.jpg";